import { Component, Input } from '@angular/core';
import Order from '../../../smoothr-web-app-core/models/Order';
import { OrderUtils } from '../../../smoothr-web-app-core/utils/order-utils';
import { numberToCurrency } from 'src/smoothr-web-app-core/utils/utils';
import { NavigationService } from 'src/app/services/navigation.service';
import { BrazeEvents, BrazeService } from '../../services/braze.service';
import { PreorderType } from 'src/smoothr-web-app-core/enums/PreorderType';
import { RepositoryService } from 'src/smoothr-web-app-core/services/repository/repository.service';

@Component({
	selector: 'app-to-order-button',
	templateUrl: './to-order-button.component.html',
	styleUrls: ['to-order-button.component.scss'],
})
export class ToOrderButtonComponent {
	@Input() order: Order;

	constructor(
		private brazeService: BrazeService,
		private navigationService: NavigationService,
		private repository: RepositoryService
	) {}

	get price(): number {
		if (!this.order || !this.order.preorder) {
			return 0;
		}
		if (this.order.preorder.type === PreorderType.FOOD_SPOT) {
			return OrderUtils.orderTotalPrice(this.order, true, true, this.repository.companyCode$.getValue() ?? null);
		}
		return OrderUtils.articleGroupsTotalPrice(
			this.order.orderedArticles,
			this.order.type,
			this.order.preorder.type,
			this.order.terminalorder ? this.order.terminalorder.type : null
		);
	}

	get formattedPrice(): string {
		return numberToCurrency(this.price, this.order.currency);
	}

	get active(): boolean {
		return !!(this.order && this.order.orderedArticles && this.order.orderedArticles.length > 0);
	}

	async goToOrder() {
		if (this.active) {
			this.brazeService.logCustomEvent(BrazeEvents.open_cart);
			await this.navigationService.order();
		}
	}
}
